import type { Invoice } from '@/types/invoice'
import { EmployeeInvoiceField, InlineField } from '@/components/common'
import { CATEGORY_OPTIONS, formatDateLong, PAYMENT_METHODS } from './invoiceUtils'

interface Props {
  invoice: Invoice
  onSave: (field: string, value: string | number | null) => Promise<unknown>
}

/** Stammdaten: Partei, Bankverbindung, Daten, Einordnung. Alles inline editierbar. */
export default function InvoiceFactsPanel({ invoice, onSave }: Props) {
  const isReminder = invoice.type === 'reminder'
  const isOutgoing = invoice.type === 'outgoing'

  return (
    <section className="rounded-lg border border-gray-200 bg-white">
      {isOutgoing ? (
        <InlineField
          label="Empfänger" field="recipient_name"
          value={invoice.recipient_name || invoice.supplier_name}
          onSave={onSave}
        />
      ) : (
        <InlineField label="Lieferant" field="supplier_name" value={invoice.supplier_name} onSave={onSave} />
      )}

      <InlineField
        label="Rechnungs-Nr." field="invoice_number" value={invoice.invoice_number}
        mono onSave={onSave}
      />

      <InlineField
        label="IBAN" field="supplier_iban" value={invoice.supplier_iban}
        mono copyValue={(invoice.supplier_iban || '').replace(/\s/g, '') || null}
        onSave={onSave}
      />

      <InlineField
        label={isReminder ? 'Mahndatum' : 'Rechnungsdatum'} field="invoice_date"
        value={invoice.invoice_date} type="date" display={formatDateLong}
        onSave={onSave}
      />

      <InlineField
        label="Fällig am" field="due_date" value={invoice.due_date} type="date"
        display={formatDateLong} placeholder={isReminder ? 'sofort fällig' : 'Klicken…'}
        onSave={onSave}
      />

      <InlineField
        label="Kategorie" field="category" value={invoice.category}
        type="select" options={CATEGORY_OPTIONS} onSave={onSave}
      />

      {!isReminder && (
        <InlineField
          label="Zahlungsart" field="payment_method" value={invoice.payment_method}
          type="select" options={PAYMENT_METHODS} onSave={onSave}
        />
      )}

      {isReminder && (
        <InlineField
          label="Mahnstufe" field="reminder_level" value={invoice.reminder_level}
          type="number" onSave={onSave}
        />
      )}

      {/* #124 — Mitarbeiter-Rechnung. Auf Mahnungen sinnlos: ausgelegt wird die
          Rechnung dahinter, die Mahnung ist nur der Nachtrag dazu. */}
      {!isReminder && (
        <EmployeeInvoiceField
          checked={invoice.is_employee_invoice}
          employeeName={invoice.employee_name}
          onSave={onSave}
        />
      )}
    </section>
  )
}
